import React from "react";
import {
    clearIncompleteDamage,
    saveIncompleteDamage,
    setClearPanelOn,
    showAddEditDamage,
    showCurrentFlatCarView,
    showDamageListView,
    showExteriorFlatCarView,
    showSuccessMessage,
    showSuggestedDamagesPanel
} from "../../../actions/globalDisplayActions";
import {addAutoDamage, addDamage, deleteDamage, updateDamage} from "../../../actions/conditionActions";
import {
    deleteDamageImage,
    getActiveImage,
    getActiveImageObject,
    hasActiveImage,
    updateDamageImage
} from "../../../actions/damageImageActions";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import update from "immutability-helper";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import Col from "@prism/col";
import Row from "@prism/row";
import {FormGroup} from "@prism/form";
import Input from "@prism/input";
import Button from "@prism/button";
import Message from "@prism/message";
import Api from "../../../components/Api";
import {connect} from "react-redux";
import OutlinePanel, {PanelHead} from "../../common/OutlinePanel";
import {ActionDropdown, DamageDropdown, SeverityDropdown,} from "./artComponents";
import TextCounter from "../../common/TextCounter";
import {APPROVALS_API_URL} from "../../../config/env";
import FlatCarPanel from "./FlatCar/FlatCarPanel";
import MultimediaViewer from "@fyusion/prism-viewer";
import ChargeableDropdown from "./artComponents/ChargeableDropdown";
import TakePhoto from "./capturePhoto/TakePhoto";
import {addAnnouncementByCode, addAnnouncementForDamage} from "../../../actions/announcementsActions";
import ErrorBoundary from "../../common/ErrorBoundary";
import SuccessMessage from "../../common/SuccessMessage";
import csrf from "../../../csrf";
import SlidePanel from "../../SlidePanel";
import DamageCalculator from "./DamageCalculator/DamageCalculator";
import Pricing from "../Pricing";
import {DamagePricingInputs} from "../../../utils/DamagePricingInputs";
import {
    CONDITION_ANNOUNCEMENT,
    FILTERED,
    FYU_DAMAGE_ANALYSIS,
    INCLUDED,
    MISSING_ESTIMATE_MESSAGE,
    MISSING_PRICING_MESSAGE,
    NO_ACTION,
    ODOMETER_INOP_ANNOUNCEMENT_CODE,
    ODOMETER_INOP_DAMAGE_KEY,
    ODOMETER_INOPERABLE,
    SMART_INSPECT
} from "../../../utils/constants";
import {clearItemsList, clearSelectedFlatCarPanel, handlePanelClick} from "../../../actions/flatCarActions";
import {damageRequiresPhoto, generateDamageId, isAutomatedDamage, isDuplicateDamageKey} from "../../../utils/utils";
import {manuallyAddSuggestedDamage} from "../../../actions/SuggestedDamageActions";
import SpinnerOverlay from "../../Spinner/SpinnerOverlay";
import {logObject} from "../../../actions/loggingActions";
import SuggestedDamages from "./SuggestedDamages";
import * as pricingUtils from "./PricingUtils"
import {formatPricingVal} from "./PricingUtils"

const itemsSearchApi = (text) =>
    Api._fetch(
        `${APPROVALS_API_URL}/smartInspect/art/items/search?description=` +
        encodeURIComponent(text)
    );
const itemsSearchAPIDebounced = AwesomeDebouncePromise(itemsSearchApi, 300);
const defaultSlidePanelZindex = 4000;

class DamageEditView extends React.Component {
    state = {
        validation: {
            itemIsValid: true,
        },
        itemValidationMessage: "",
        text: "",
        options: [],
        itemSearchResults: [],
        showPricing: false,
        pricingTypes: [],
        isUpdate: false,
        isLoading: false,
        chargeable: null,
        damageKey: "",
        pricingDamageImageRequired: 'N',
        damageImageRequired: 'N',
        isDuplicateDamage: false,
        showCalculator: false,
        damageEstimatorQuestions: [],
        manufactureCode: null,
        directReturnCode: null,
        actionCodeFromArt: null,
        categoryCode: null,
        actionFromArt: null,
        showTurnInCalculator: false,
        showPricingInputError: false,
        showEstimateError: false,
        locationCode: "",
        isApiLoading: false,
        sourcePlatform: null,
        validationFailed: false,
        disabled: true,
        isAutoDamage: null,
        damageNotChargeable: null
    };

    componentDidMount() {
        let damage = (this.props.globalDisplay.currentDamage && this.props.globalDisplay.currentDamage.item) ?
            this.props.globalDisplay.currentDamage : null;
        const isEdit = !!damage;
        if (!damage) {
            damage = (this.props.globalDisplay.incompleteDamage && this.props.globalDisplay.incompleteDamage.item) ?
                this.props.globalDisplay.incompleteDamage : null;
        }
        if (!!damage) {
            this.setState({
                ...damage,
                originalDamageKey: damage.damageKey,
                damageKeyAtWorkOrderLoad: damage.damageKeyAtWorkOrderLoad,
                text: damage.item,
                options: [damage.item],
                selectedItem: [damage.item],
                isUpdate: isEdit,
                hasImage: this.props.hasActiveImage(damage.damageId),
                showImage: !!this.props.hasActiveImage(damage.damageId),
                manufactureCode: this.props.consignment.manufactureCode,
                directReturnCode: this.props.damageRules.directReturnCode === 'Y' ? 'YES' : this.props.damageRules.directReturnCode,
                categoryCode: this.props.consignment.categoryCode,
                showTurnInCalculator: (this.props.damageRules.directReturnCode === 'Y' && this.props.consignment.manufactureCode === "FOR") || (this.props.consignment.categoryCode === "TRP" && this.props.consignment.manufactureCode === "TOY"),
                sourcePlatform: damage.sourcePlatform,
                isApiLoading: true,
                disabled: false,
                isAutoDamage: isAutomatedDamage(this.props.automatedDamages, damage.damageKey),
                damageNotChargeable: damage.actionCode === INCLUDED || damage.actionCode === NO_ACTION,
                damageId: damage.damageId
            }, async () => {
                this.setState({isApiLoading: false});

                await this.updateDamagePricing([damage], false);

                if (this.state.actionCode !== NO_ACTION && this.state.actionCode !== INCLUDED) {
                    await this.validatePricing();
                }
            });
        } else {
            const newDamageId = generateDamageId();

            this.setState({
                manufactureCode: this.props.consignment.manufactureCode,
                directReturnCode: this.props.damageRules.directReturnCode === 'Y' ? 'YES' : this.props.damageRules.directReturnCode,
                categoryCode: this.props.consignment.categoryCode,
                showTurnInCalculator: (this.props.damageRules.directReturnCode === 'Y' && this.props.consignment.manufactureCode === "FOR") || (this.props.consignment.categoryCode === "TRP" && this.props.consignment.manufactureCode === "TOY"),
                isApiLoading: false,
                damageId: newDamageId
            }, async () => {
            });

            this.scrollToTop();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((prevProps.damageImages !== this.props.damageImages) && this.props.hasActiveImage(this.state.damageId)) {
            this.setState({
                showImage: true
            })
        }

        if (this.shouldClearDamageFields(prevProps)) {
            this.props.clearItemsList();
            this.clearPageValues();
        }
    }

    handleItemChange = async (event) => {
        if (event.length) {
            const item = this.itemInSearchResults(event[0].label);
            if (item !== undefined) {
                await this.setState({
                    itemCode: item.itemCode,
                    subItemCode: item.subItemCode,
                    locationCode: item.locationCode,
                    areaCode: item.areaCode,
                    description: item.description,
                    item: item.description
                }, async () => {
                });
                this.persistIncompleteDamage();
            }
        } else {
            if (event.length === 0) {
                this.setState({
                    options: []
                })
                this.wipeoutIncompleteDamage();
            }
            this.clearSelectedItem();
        }
    };

    shouldClearDamageFields = (prevProps) => {
        const addNewDamageButtonClicked = prevProps.globalDisplay.displaySuggestedDamages && !!this.panelSuggestedDamages()
            && !(this.props.globalDisplay.displaySuggestedDamages);
        const panelDisplayingSuggestedDamages = this.props.globalDisplay.displaySuggestedDamages && !!this.panelSuggestedDamages();
        const panelChanged = !panelDisplayingSuggestedDamages && prevProps.globalDisplay.selectedFlatCarPanel
            && (prevProps.globalDisplay.selectedFlatCarPanel !== this.props.globalDisplay.selectedFlatCarPanel);

        return addNewDamageButtonClicked || panelChanged;
    }

    handleTextChange = async (text) => {
        const isValid = this.validateInput(text);
        if (!isValid) {
            this.clearSelectedItem();
        }
        await this.setState({text: text});

        const foundItem = this.itemInSearchResults(text);
        if (foundItem) {
            this.setSelectedItem(foundItem);
        } else if (isValid) {
            this.clearSelectedItem();
            const result = await this.fetchItemSearchResults(text.toLowerCase());
            if (!result.items) {

            } else if (result.items.length === 0) {
                this.setItemValidationMessageWithResults(
                    "Not a valid damage item. Please re-enter",
                    false,
                    result.items
                );
            } else {
                this.setItemValidationMessageWithResults("", true, result.items);
            }
        }
    };

    validateInput = (text) => {
        if (text.length < 3) {
            this.setItemValidationMessage(
                "Please enter at least 3 characters in the search",
                false,
                false
            );
            return false;
        } else {
            this.setItemValidationMessage("", true, true);
            return true;
        }
    };

    setItemValidationMessage = (message, isValid, isCharLimitExceed) => {
        let newState = update(this.state, {
            itemValidationMessage: {$set: message},
            validation: {$merge: {itemIsValid: isValid}},
        });
        if (isCharLimitExceed) {
            newState = update(newState, {
                $merge: {fetchInProgress: false, isLoading: false},
            });
        }
        this.setState(newState);
    };

    clearPageValues = () => {
        if (this._typeahead) {
            this._typeahead.clear();
        }
        this.damageCommentsRef.handleChange({target: {value: ''}})
        if (pricingUtils.isCRSO(this.props.condition)) {
            this.partDescriptionRef.handleChange({target: {value: ''}})
        }
        this.setState({
            damageId: generateDamageId(),
            item: "",
            itemCode: "",
            subItemCode: "",
            damageCode: null,
            severityCode: null,
            actionCode: null,
            chargeable: null,
            damageKey: "",
            partDescription: null,
            itemSearchResults: [],
            disabled: true,
            selectedItem: null,
            text: "",
            options: [],
            notes: null,
            showImage: false,
            isDuplicateDamage: false,
            pricePlanIds: null,
            actionCodeFromArt: null,
            actionFromArt: null,
            showPricingInputError: false,
            damageImageRequired: 'N',
            repairLaborCost: '0.00',
            repairLaborHours: '0.00',
            paintLaborCost: '0.00',
            paintLaborHours: '0.00',
            partLaborCost: '0.00',
            partLaborHours: '0.00',
            partCost: '0.00',
            finalPartCost: '0.00',
            damageNotChargeable: null
        });
        this.wipeoutIncompleteDamage();
    };

    clearSelectedItem = () => {
        this.setState({
            item: "",
            itemCode: "",
            subItemCode: "",
            damageCode: "",
            severityCode: "",
            actionCode: "",
            chargeable: "",
            damageKey: "",
            itemSearchResults: [],
            disabled: true,
            selectedItem: null,
            isDuplicateDamage: false,
            actionCodeFromArt: "",
            actionFromArt: "",
            damageNotChargeable: null
        });
    };

    setSelectedItem = (item) => {
        this.setState({
            ...item,
            damageCode: "",
            severityCode: "",
            actionCode: "",
            chargeable: "",
            disabled: true,
            selectedItem: null,
            isDuplicateDamage: false,
            actionCodeFromArt: "",
            actionFromArt: "",
        }, () => this.setState({damageKey: pricingUtils.getDamageKey(this.state)}));
    };

    setSelectedItemFromFlatCar = (item) => {
        this.setState({
            item: item.description,
            itemCode: item.itemCode,
            subItemCode: item.subItemCode,
            areaCode: item.areaCode,
            locationCode: item.locationCode,
            sequence: item.sequence,
            text: item.description,
            options: [item.description],
            selectedItem: [item.description],
            damageCode: "",
            severityCode: "",
            actionCode: "",
            chargeable: "",
            disabled: true,
            isDuplicateDamage: false,
            actionCodeFromArt: "",
            actionFromArt: "",
        }, () => {
            this.setState({damageKey: pricingUtils.getDamageKey(this.state)});
            this.persistIncompleteDamage();
        });
    };

    itemInSearchResults = (text) => {
        return this.state.itemSearchResults.find(
            (item) => item.description === text
        );
    };

    showItemList = () => {
        const hasValidItems =
            this.state.text.length > 2 && this.state.options.length;
        const itemHasBeenSelected = this.state.itemCode !== "";
        return !!hasValidItems && !itemHasBeenSelected;
    };

    requiredFieldsCompleted = () => {
        return (
            this.state.itemCode &&
            this.state.subItemCode &&
            this.state.damageCode &&
            this.state.severityCode &&
            this.state.chargeable &&
            (this.photoIsRequired() ? this.props.hasActiveImage(this.state.damageId) : true)
        );
    };

    saveButtonDisabled = () => {
        return !this.requiredFieldsCompleted()
            || this.state.isDuplicateDamage
            || (pricingUtils.isCRSO(this.props.condition) && this.state.showPricingInputError)
            || this.state.isLoading
            || this.state.isApiLoading
            || this.state.validationFailed;
    };

    handleDamageChange = async ({target: {options, selectedIndex, value}}) => {
        await this.setState({
            damageCode: value,
            damage: options[selectedIndex].text,
            actionCode: null,
            action: null,
            actionCodeFromArt: null,
            actionFromArt: null,
            severityCode: null,
            severity: null,
            chargeableDescription: null,
            chargeable: null,
            statusMessage: {text: "", color: ""},
            disabled: true,
            isDuplicateDamage: this.isDuplicateDamage(value),
            showImage: this.isDuplicateDamage(value) ? false : this.state.showImage,
            suggestedDamageExists: this.isSuggestedDamageAvailable(value)
        }, () => this.setState({damageKey: pricingUtils.getDamageKey(this.state)}));
        this.persistIncompleteDamage();
    };

    handleSeverityChange = async ({target: {options, selectedIndex, value}}) => {
        await this.setState({
            severityCode: value,
            severity: options[selectedIndex].text,
            chargeableDescription: null,
            chargeable: null,
            actionCode: null,
            action: null,
            statusMessage: {text: "", color: ""},
            disabled: true,
            showTurnInCalculator: this.isFordOrToyota()
        }, () => this.setState({damageKey: pricingUtils.getDamageKey(this.state)}));
        this.persistIncompleteDamage();
    };

    resetPricingFields() {
        this.setState({
            repairLaborHours: null,
            repairLaborCost: null,
            paintLaborHours: null,
            paintLaborCost: null,
            partLaborHours: null,
            partLaborCost: null,
            partCost: null,
            finalPartCost: null,
            pricePlanIds: null,
            damageNotChargeable: null
        });
    }

    resetPricingAndErrorFlag = async () => {
        this.resetDamagePricing();
        this.setState({showPricingInputError: false, showEstimateError: false, damageNotChargeable: true})
    }

    getEstimate = async () => {
        let estimateResponse;
        try {
            this.setState({isApiLoading: true});
            estimateResponse = await pricingUtils.fetchEstimate(this.props, this.state);
            this.setState({isApiLoading: false});
        } catch (e) {
            this.setState({isApiLoading: false});
            await this.handleShowEstimateError();
            throw new Error("Error fetching estimate");
        }
        return estimateResponse;
    }

    async handlePricing() {
        this.resetPricingFields();
        let estimateResponse;
        try {
            estimateResponse = await this.getEstimate();
        } catch (e) {
            return;
        }
        const {
            overlays,
            pricingTypes
        } = await pricingUtils.getPricingTypesAndOverlays(estimateResponse)
        const estimatorQuestions = await this.fetchDamageEstimatorQuestions();
        await this.setDamageEstimatorQuestions(estimatorQuestions);
        if (!!estimateResponse && Object.keys(estimateResponse).length !== 0) {
            await this.setDamagePricePlans(estimateResponse)
            await this.setPricingProperties(pricingTypes, overlays);
            const callPricing = overlays.length !== 0 && pricingTypes.length === 0;
            if (!estimatorQuestions?.questions?.length && callPricing) {
                await this.getAndValidatePricing();
            }
        } else {
            this.resetDamagePricing();
            const pricingErrors = pricingUtils.getPricingErrors(pricingUtils.isCRSO(this.props.condition), this.state);
            this.setState({
                showPricingInputError: pricingErrors.showPricingInputError,
                showEstimateError: pricingErrors.showEstimateError,
                fetchPricingOnCancel: false
            })
        }
    }

    async setPricingProperties(pricingTypes, overlays) {
        let fetchPricingOnCancel = !(pricingTypes.length === 0 && overlays.length === 0);
        if (pricingTypes.length === 0 && overlays.length === 0) {
            this.resetDamagePricing();
            await this.validatePricing();
        }
        this.setState({
            pricingTypes,
            showPricing: pricingTypes.length !== 0,
            fetchPricingOnCancel
        });
    }

    async getAndValidatePricing() {
        const damageKey = pricingUtils.getDamageKey(this.state, false)
        const response = await this.getPricing(pricingUtils.buildDamage(this.state, damageKey));
        if (Array.isArray(response) && !!response.length) {
            await this.updateDamagePricing(response, false)
        }
        await this.validatePricing();
    }

    updateAction = ({target: {options, selectedIndex, value}}) => {
        if (pricingUtils.isCRSO(this.props.condition)) {
            // This is the rental return scenario
            if (value && this.state.actionCode !== value) {
                this.setState({
                    actionCode: value,
                    action: options[selectedIndex].text,
                    statusMessage: {text: '', color: ''},
                    disabled: false,
                    damageEstimatorQuestions: [],
                    showCalculator: false
                }, async () => {
                    await this.updatePricing(value);
                });
            } else if (this.state.actionCodeFromArt !== this.state.actionCode) {
                this.setState({
                    actionCode: this.state.actionCodeFromArt,
                    action: this.state.actionFromArt,
                    statusMessage: {text: '', color: ''},
                    disabled: false,
                    damageEstimatorQuestions: [],
                    showCalculator: false
                }, async () => {
                    await this.updatePricing(this.state.actionCodeFromArt);
                });
            }
        }
    };

    handleActionChange = async ({target: {options, selectedIndex, value}}) => {
        if (pricingUtils.isCRSO(this.props.condition) && this.state.showTurnInCalculator) {
            await this.setState({
                actionCodeFromArt: value,
                actionFromArt: options[selectedIndex].text,
            }, async () => {
                const estimatorQuestions = await this.fetchDamageEstimatorQuestions();
                await this.setDamageEstimatorQuestions(estimatorQuestions);
                if (!estimatorQuestions?.questions?.length) {
                    await this.setState({
                        actionCode: value,
                        action: options[selectedIndex].text,
                        statusMessage: {text: '', color: ''},
                        disabled: false,
                        damageEstimatorQuestions: [],
                        showTurnInCalculator: false
                    }, async () => {
                        await this.updatePricing(value);
                    });
                    this.persistIncompleteDamage();
                }
            });
            this.persistIncompleteDamage();
            return;
        }
        if (pricingUtils.isCRSO(this.props.condition) && this.state.actionCode !== value) {
            this.setState({
                actionCode: value,
                action: options[selectedIndex].text,
                statusMessage: {text: '', color: ''},
                disabled: false,
                damageEstimatorQuestions: [],
                showPricingInputError: false
            }, async () => {
                await this.updatePricing(value);
            });

        } else {
            this.setState({
                actionCode: value,
                action: options[selectedIndex].text,
                statusMessage: {text: "", color: ""},
                disabled: false,
                damageEstimatorQuestions: [],
                showPricingInputError: false,
                showEstimateError: false
            }, () => this.setState({damageKey: pricingUtils.getDamageKey(this.state)}));
        }
    };

    updatePricing = async (value) => {
        if (await pricingUtils.damageDoesNotNeedPricing(value)) {
            await this.resetPricingAndErrorFlag()
        } else {
            await this.handlePricing();
        }
    }

    setDamageEstimatorQuestions = async (response) => {
        if (!!response?.questions?.length && this.pricingIsEmpty()) {
            this.setState({
                showCalculator: true,
                damageEstimatorQuestions: response,
                isApiLoading: false
            });
        } else if (response.status === 404) {
            this.setState({
                showCalculator: false,
                showTurnInCalculator: false,
                isApiLoading: false
            });
        } else {
            this.setState({
                showCalculator: false,
                showTurnInCalculator: false,
                isApiLoading: false
            });
            this.setErrorMessage("Error calling the estimator, try again later")
        }
    }

    fetchDamageEstimatorQuestions = async () => {
        this.setState({
            damageEstimatorQuestions: [],
            isApiLoading: true
        });
        const questions = await Api.getDamageEstimatorQuestions(this.buildQuestionParams());
        this.setState({isApiLoading: false});
        return questions;
    }

    buildQuestionParams() {
        let headers = csrf.getCSRFHeaders();
        headers['Content-Type'] = 'application/json';
        let params = {
            itemCode: this.state.itemCode,
            subItemCode: this.state.subItemCode,
            damageCode: this.state.damageCode,
            severityCode: this.state.severityCode,
            headers: headers
        }
        if (this.isFord() && this.state.showTurnInCalculator) {
            params.manufactureCode = this.state.manufactureCode
            params.directTurnIn = this.state.directReturnCode
        } else if (this.isToyota() && this.state.showTurnInCalculator) {
            params.manufactureCode = this.state.manufactureCode
            params.categoryCode = this.state.categoryCode
        } else {
            params.actionCode = this.state.actionCode
            params.chargeable = this.state.chargeable
        }
        return params;
    }

    updatePricingForDamage = async ({repairLaborCost, repairLaborHours, aluminum}) => {
        await this.updatePricingFromDamageEstimator({repairLaborCost, repairLaborHours, aluminum});
        await this.getAndValidatePricing();
    };

    resetTurnInCalculatorFlag = () => {
        this.setState({showTurnInCalculator: false})
    };

    updatePricingFromDamageEstimator = async ({repairLaborCost, repairLaborHours, aluminum}) => {
        repairLaborCost && this.setState({repairLaborCost: repairLaborCost, showCalculator: false});
        repairLaborHours && this.setState({
            repairLaborHours: repairLaborHours,
            repairLaborCost: null,
            showCalculator: false
        });
        this.setState({aluminum: aluminum, showCalculator: false});
    };

    isFordOrToyota = () => {
        return ((this.state.directReturnCode === 'YES' && this.state.manufactureCode === "FOR") || (this.state.categoryCode === "TRP" && this.state.manufactureCode === "TOY"));
    }

    isFord = () => {
        return ((this.state.directReturnCode === 'YES' && this.state.manufactureCode === "FOR"));
    }

    isToyota = () => {
        return (this.state.categoryCode === "TRP" && this.state.manufactureCode === "TOY");
    }

    hideDamageCalculator = () => {
        if (!!this.state.damageEstimatorQuestions && this.isRentalReturnType()) {
            this.setState({showCalculator: false, severityCode: null},
                async () => {
                    if (this.state.fetchPricingOnCancel) {
                        await this.getAndValidatePricing();
                    }
                });
        } else {
            this.setState({showCalculator: false},
                async () => {
                    if (this.state.fetchPricingOnCancel) {
                        await this.getAndValidatePricing();
                    }
                });
        }
    }

    showDamageCalculator = async () => {
        if (this.isFordOrToyota()) {
            await this.setState({showTurnInCalculator: this.isFordOrToyota()});
            const estimatorQuestions = await this.fetchDamageEstimatorQuestions();
            await this.setDamageEstimatorQuestions(estimatorQuestions);
            if (!estimatorQuestions?.questions?.length) {
                await this.setState({
                    damageEstimatorQuestions: [],
                    showTurnInCalculator: false
                }, async () => {
                    await this.updatePricing(this.state.actionCode);
                });
            }
        } else {
            await this.updatePricing(this.state.actionCode);
        }
    };

    resetDamagePricing = () => {
        this.setState({
            damageImageRequired: 'N',
            repairLaborCost: '0.00',
            repairLaborHours: '0',
            paintLaborCost: '0.00',
            paintLaborHours: '0',
            partLaborCost: '0.00',
            partLaborHours: '0',
            partCost: '0.00',
            finalPartCost: '0.00'
        });
    }

    handleShowEstimateError = async () => {
        this.resetDamagePricing();
        this.setState({
            disabled: false,
            showPricingInputError: true,
            showEstimateError: true
        })
    }

    setDamagePricePlans = async (estimateResponse) => {
        const pricePlans = await pricingUtils.getPricePlans(estimateResponse);
        let pricePlanIds = this.state.pricePlanIds || [];
        pricePlanIds = pricePlanIds.concat(pricePlans);
        this.setState({pricePlanIds})
    };

    isRentalReturnType = () => {
        return pricingUtils.isRentalReturnType(this.state.damageEstimatorQuestions);
    }

    getPricing = async (damage) => {
        let response;
        try {
            this.setState({isApiLoading: true});
            response = await pricingUtils.fetchPricing(this.props, damage);
            this.setState({isApiLoading: false});
        } catch (e) {
            this.setState({isApiLoading: false});
            this.setStatusMessage("Error fetching pricing");
            return e;
        }
        return response;
    }

    validatePricing = async () => {
        if (pricingUtils.isCRSO(this.props.condition)) {
            const pricingErrors = pricingUtils.getPricingErrors(pricingUtils.isCRSO(this.props.condition), this.state);
            this.setState({
                showPricingInputError: pricingErrors.showPricingInputError,
                showEstimateError: pricingErrors.showEstimateError
            })
        }
    }

    updateDamagePricing = async (pricingResponse, isHours) => {
        this.props.logObject('DamageEditView', 'updateDamagePricing', 'pricingResponse', pricingResponse)
        const finalPricing = await pricingUtils.getFinalPricing(pricingResponse);
        if (isHours) {
            await this.setState({
                partLaborHours: finalPricing.partLaborHours,
                partLaborCost: finalPricing.partLaborCost,
                paintLaborHours: finalPricing.paintLaborHours,
                paintLaborCost: finalPricing.paintLaborCost,
                repairLaborHours: finalPricing.repairLaborHours,
                repairLaborCost: finalPricing.repairLaborCost,
                partDescription: finalPricing.partDescription,
                pricingDamageImageRequired: finalPricing.pricingDamageImageRequired,
                damageImageRequired: finalPricing.damageImageRequired
            }, () => this.props.logObject('DamageEditView', 'updateDamagePricing-isHours', 'state', this.state))

        } else {
            await this.setState({
                partLaborHours: finalPricing.partLaborHours,
                partLaborCost: finalPricing.partLaborCost,
                paintLaborHours: finalPricing.paintLaborHours,
                paintLaborCost: finalPricing.paintLaborCost,
                repairLaborHours: finalPricing.repairLaborHours,
                repairLaborCost: finalPricing.repairLaborCost,
                partCost: finalPricing.partCost,
                finalPartCost: finalPricing.finalPartCost,
                partDescription: finalPricing.partDescription,
                pricingDamageImageRequired: finalPricing.pricingDamageImageRequired,
                damageImageRequired: finalPricing.damageImageRequired
            }, () => this.props.logObject('DamageEditView', 'updateDamagePricing-isNotHours', 'state', this.state));
        }

        this.persistIncompleteDamage();
    };

    handleManualUpdatePricing = async (event) => {
        if (pricingUtils.costFieldWasUpdated(event.target.name)) {
            await this.formatCurrency(event);
            await this.updateManualDamagePricing();
            await this.validatePricing();
        }
    }

    updateManualDamagePricing = async () => {
        const partLaborCost = pricingUtils.getFinalCost(this.state.partLaborCost);
        const paintLaborCost = pricingUtils.getFinalCost(this.state.paintLaborCost);
        const repairLaborCost = pricingUtils.getFinalCost(this.state.repairLaborCost);
        const finalPartCost = pricingUtils.getFinalCost(this.state.finalPartCost);
        const partCost = pricingUtils.getFinalCost(this.state.partCost);
        const damageImageRequired = pricingUtils.getDamageImageRequired(repairLaborCost, paintLaborCost, partLaborCost, finalPartCost, partCost, this.state.pricingDamageImageRequired)
        this.setState({
            partLaborCost,
            paintLaborCost,
            repairLaborCost,
            finalPartCost,
            partCost,
            damageImageRequired
        });
        this.persistIncompleteDamage();
    }

    handleChargeableChange = async ({target: {options, selectedIndex, value}}) => {
        await this.setState({
            chargeable: value,
            chargeableDescription: options[selectedIndex].text,
        });
        this.persistIncompleteDamage();
    };

    handleNotesChange = async (event) => {
        await this.setState({
            notes: event.value,
        });
        this.persistIncompleteDamage();
    };

    handleEditPartDescriptionChange = async (event) => {
        await this.setState({
            partDescription: event.value,
        });
        this.persistIncompleteDamage();
    };

    fetchItemSearchResults = async (text) => {
        this.setState({isLoading: true});
        const result = await itemsSearchAPIDebounced(text);

        if (result.ok) {
            this.setState({isLoading: false});
            return result.json();
        } else {
            this.setState({isLoading: false});
            this.setStatusMessage(
                "Error retrieving Item list please try again later"
            );
            return {items: []};
        }
    };

    handleSuggestedDamagesToggle = async (selectedFlatCarPanel) => {
        this.setState({isApiLoading: true});
        await this.props.handlePanelClick(selectedFlatCarPanel);
        this.setState({isApiLoading: false});
    };

    setItemValidationMessageWithResults = (message, isValid, results) => {
        let newState = update(this.state, {
            itemValidationMessage: {$set: message},
            validation: {$merge: {itemIsValid: isValid}},
        });

        let itemList = [];
        results.forEach(function (entry) {
            const item = {id: entry.code, label: entry.description};
            itemList.push(item);
        });

        newState = update(newState, {
            $merge: {
                itemSearchResults: results,
                options: itemList,
                isLoading: false,
            },
        });

        this.setState(newState);
    };

    setStatusMessage = (message) => {
        console.log("ERR MSG", message);
    };

    // IMPORTANT: this needs to be called AFTER React state has been updated!!
    persistIncompleteDamage = () => {
        if (!this.state.isUpdate) {
            const damage = this.buildDamageObject();
            damage.damageEstimatorQuestions = this.state.damageEstimatorQuestions
            this.props.saveIncompleteDamage(damage);
        }
    }

    // IMPORTANT: this needs to be called AFTER React state has been updated!!
    wipeoutIncompleteDamage = () => {
        if (!this.state.isUpdate) {
            this.props.clearIncompleteDamage();
        }
    }

    needsArtItemApiCall = (damage) => {
        if (this.state.originalDamageKey) {
            const damageKeyArray = this.state.originalDamageKey.split('-');
            const itemCode = damageKeyArray[1];
            const subItemCode = damageKeyArray[2];

            return !(this.state.isUpdate
                && itemCode === damage.itemCode
                && subItemCode === damage.subItemCode
                && this.props.globalDisplay.currentDamage?.panelId)
        }
        return true;
    }

    handleSaveDamage = async () => {
        const damage = this.buildDamageObject();
        console.log(`Save clicked for ${damage.item} ${damage.damage} with damageId ${damage.damageId}`)

        if (this.needsArtItemApiCall(damage)) {
            const artItem = await Api.getArtItem(damage.itemCode, damage.subItemCode);

            if (!!artItem.panelId) {
                damage.panelId = artItem.panelId;
            }
        }

        if (this.state.isUpdate) {
            let newDamageKey = `L1-${damage.itemCode}-${damage.subItemCode}-${damage.damageCode}`
            // TODO Spoke with Caroline. There is a card in the backlog to handle other manually-added auto damages too.
            if (newDamageKey === ODOMETER_INOP_DAMAGE_KEY) {
                // When converting manual damage to auto damage, delete from manual list and add to auto list
                this.props.deleteDamage(this.props.globalDisplay.currentDamage, this.props.condition);
                this.props.addAutoDamage(damage);
                this.props.addAnnouncementByCode(CONDITION_ANNOUNCEMENT, ODOMETER_INOP_ANNOUNCEMENT_CODE, ODOMETER_INOPERABLE);
            } else {
                this.props.updateDamage(damage, this.props.condition, this.state.originalDamageKey);
                this.props.addAnnouncementForDamage(damage);
            }
            this.props.showDamageListView();
        } else {
            // TODO Spoke with Caroline. There is a card in the backlog to handle other manually-added auto damages too.
            if (damage.damageKey === ODOMETER_INOP_DAMAGE_KEY) {
                this.props.addAutoDamage(damage);
                this.props.addAnnouncementByCode(CONDITION_ANNOUNCEMENT, ODOMETER_INOP_ANNOUNCEMENT_CODE, ODOMETER_INOPERABLE);
            } else {
                if (!this.state.isDuplicateDamage && this.state.suggestedDamageExists) {
                    this.props.suggestedDamages?.damages.every(suggestedDamage => {
                        if ((damage.damageKey === suggestedDamage.artCodes.damageKey) && suggestedDamage.action !== FILTERED) {
                            this.props.manuallyAddSuggestedDamage(suggestedDamage.artCodes.damageKey);
                            return false;
                        }
                        return true;
                    });
                }
                this.props.addDamage(damage);
                this.props.addAnnouncementForDamage(damage);
            }
            await this.clearPageValues();
            this.scrollToTop();
            this.props.showCurrentFlatCarView(this.props.globalDisplay.flatCarView);
        }

        if (this.props.globalDisplay.clearSelectedPanel) {
            this.flatCarRef && this.flatCarRef.clearAllSelections();
            if (!this.panelSuggestedDamages()) {
                this.props.clearSelectedFlatCarPanel();
            }
        } else {
            this.props.showDamageListView();
            this.props.showSuggestedDamagesPanel();
            this.props.setClearPanelOn();
        }
    };

    handleCancelClick = () => {
        this.scrollToTop();
        this.props.showSuggestedDamagesPanel();
        if (this.props.suggestedDamages) {
            this.props.clearItemsList();
        } else if (!this.flatCarRef) {
            this.props.clearItemsList();
            this.props.clearSelectedFlatCarPanel();
        } else {
            this.flatCarRef.clearAllSelections();
        }
        this.props.showDamageListView();
        this.props.setClearPanelOn();
        this.clearPageValues();
    };

    buildDamageObject = () => {
        return {
            item: this.state.item,
            itemCode: this.state.itemCode,
            subItemCode: this.state.subItemCode,
            damage: this.state.damage,
            damageCode: this.state.damageCode,
            severity: this.state.severity,
            severityCode: this.state.severityCode,
            action: this.state.action,
            actionCode: this.state.actionCode,
            locationCode: this.state.locationCode,
            damageKey: (this.state.isUpdate ? this.state.originalDamageKey : this.state.damageKey),
            notes: this.state.notes,
            chargeable: this.state.chargeable,
            chargeableDescription: this.state.chargeableDescription,
            damageKeyAtWorkOrderLoad: this.state.damageKeyAtWorkOrderLoad,
            hasImage: this.props.hasActiveImage(this.state.damageId),
            repairLaborHours: parseFloat(this.state.repairLaborHours),
            repairLaborCost: parseFloat(this.state.repairLaborCost),
            paintLaborHours: parseFloat(this.state.paintLaborHours),
            paintLaborCost: parseFloat(this.state.paintLaborCost),
            partLaborHours: parseFloat(this.state.partLaborHours),
            partLaborCost: parseFloat(this.state.partLaborCost),
            partCost: parseFloat(this.state.partCost),
            finalPartCost: parseFloat(this.state.finalPartCost),
            partDescription: this.state.partDescription,
            aluminum: this.state.aluminum,
            sourcePlatform: this.getSourcePlatform(),
            damageImageRequired: this.state.damageImageRequired,
            pricePlanIds: this.state.pricePlanIds,
            damageId: this.state.damageId
        };
    };

    getSourcePlatform() {
        return this.state.sourcePlatform === FYU_DAMAGE_ANALYSIS ? FYU_DAMAGE_ANALYSIS : SMART_INSPECT;
    }

    toggleFlatCar = () => {
        this.setState({
            showImage: !this.state.showImage
        });
    };

    photoIsRequired = () => {
        return damageRequiresPhoto(this.buildDamageObject(), this.props.condition.conditionType)
    };

    scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    isDuplicateDamage = (damageCode) => {
        const newlyEnteredDamageKey = `L1-${this.state.itemCode}-${this.state.subItemCode}-${damageCode}`
        if (!this.props.condition.damages) {
            return false;
        } else if (this.state.isUpdate && newlyEnteredDamageKey === this.props.globalDisplay.currentDamage?.damageKey) {
            return false;
        } else {
            return !!this.props.condition.damages.find(damage => isDuplicateDamageKey(damage.damageKey, newlyEnteredDamageKey))
        }
    }

    isSuggestedDamageAvailable = (damageCode) => {
        const newlyEnteredDamageKey = `L1-${this.state.itemCode}-${this.state.subItemCode}-${damageCode}`
        if (this.props.globalDisplay.currentDamage === null || newlyEnteredDamageKey === this.props.globalDisplay.currentDamage.damageKey) {
            return false;
        }
        return !!this.props.suggestedDamages?.damages.find(damage => damage.artCodes.damageKey.startsWith(newlyEnteredDamageKey))
    }

    handlePricingUpdate = async (damage) => {
        await this.setState({
            pricePlanIds: damage.pricePlanIds,
            paintLaborHours: null,
            paintLaborCost: null,
            partLaborHours: null,
            partLaborCost: null,
            partCost: null,
            finalPartCost: null
        }, async () => {
            await this.getAndValidatePricing();
        });
        this.persistIncompleteDamage();
    };

    hidePricingOverlay = async () => {
        await this.setState({
            showPricing: false
        }, () => {
        })
    };

    handleUpdatePricing = async (event) => {
        const pricingField = event.target.name;
        const damageKey = pricingUtils.getDamageKey(this.state, false)
        const damage = pricingUtils.getDamageForManualPricingInput(pricingField, this.state, damageKey);
        const isHours = pricingField !== 'partCost';
        const response = await this.getPricing(damage);
        if (Array.isArray(response) && !!response.length) {
            await this.updateDamagePricing(response, isHours)
        }
        await this.validatePricing();
    };

    handlePriceChange = async (event) => {
        await this.updateInputState(event);
        await this.validatePricing();
    };

    updateInputState = (event) => {
        let value = formatPricingVal(event?.target?.value)

        return new Promise(async (resolve) => {
            await this.setState({[event.currentTarget.name]: value}, resolve)
            this.persistIncompleteDamage();
        })
    }

    handleInputValidation = (dataFromChild) => {
        this.setState(dataFromChild);
    }

    formatCurrency = async (event) => {
        this.setState({
            [event.target.name]: pricingUtils.formatCurrency(event)
        });
    };

    pricingIsEmpty = () => {
        return ((!Number(this.state.repairLaborCost) || this.state.repairLaborCost < 0) &&
            (!Number(this.state.paintLaborCost) || this.state.paintLaborCost < 0) &&
            (!Number(this.state.partLaborCost) || this.state.partLaborCost < 0) &&
            (!Number(this.state.partCost) || this.state.partCost < 0) &&
            (!Number(this.state.finalPartCost) || this.state.finalPartCost < 0));
    };

    cancelPricingOverlay = async () => {
        this.setState({
            repairLaborCost: '0.00',
            repairLaborHours: 0.0,
            paintLaborCost: '0.00',
            paintLaborHours: 0.0,
            partLaborCost: '0.00',
            partLaborHours: 0.0,
            partCost: '0.00',
            finalPartCost: '0.00',
            showPricing: false,
            pricePlanIds: []
        }, async () => {
            await this.validatePricing();
        })
    };

    resetTransform = () => {
        if (this.flatCarRef) {
            this.flatCarRef.resetTransform();
        }
    }

    getDamageImage = () => {
        return this.props.getActiveImage(this.state.damageId)
    }

    hasActivePhoto = () => {
        return this.props.hasActiveImage(this.state.damageId);
    }

    isDuplicateSuggestedDamage = (suggestedDamage) => {
        return !!this.props.condition.damages?.find(damage => damage.damageId === suggestedDamage.artCodes.damageId);
    }

    activeDamageOnPanel = (damage) => {
        return damage.artCodes.panelId === this.props.globalDisplay.selectedFlatCarPanel && !damage.action;
    }

    panelSuggestedDamages = () => {
        return (!!this.props.suggestedDamages && this.props.globalDisplay.selectedFlatCarPanel != null) ?
            this.props.suggestedDamages?.damages.find(damage => (this.activeDamageOnPanel(damage) && !this.isDuplicateSuggestedDamage(damage))) : null;
    }

    setApiLoading = (value) => {
        this.setState({isApiLoading: value});
    }

    render() {
        const isCRSO = pricingUtils.isCRSO(this.props.condition)
        return (
            <>
                <SuccessMessage/>
                {this.state.isApiLoading && (
                    <SpinnerOverlay id='loading-spinner' showCancelButton={false} size={100}/>
                )}
                {(this.hasActivePhoto()) &&
                this.state.showImage ? (
                    <ErrorBoundary>
                        <MultimediaViewer
                            id="damage-image-content"
                            hideAddOns={true}
                            key={this.props.globalDisplay.damageImageChecksum}
                            data={[
                                {
                                    category: "DMG",
                                    src: {
                                        thumbnail: "",
                                        lowRes: this.getDamageImage(),
                                    },
                                    description: this.state.item,
                                    damageKey: this.state.damageKey,
                                },
                            ]}
                        />
                    </ErrorBoundary>
                ) : (
                    <FlatCarPanel setSelectedItem={this.setSelectedItemFromFlatCar}
                                  ref={(ref) => this.flatCarRef = ref}
                                  isApiLoading={this.state.isApiLoading}
                                  hideItemSearch={(this.props.globalDisplay.displaySuggestedDamages && !!this.panelSuggestedDamages())}
                                  itemFieldText={this.state.text}
                                  callItemAPIOnSuggestedDamagesToggleChange={this.handleSuggestedDamagesToggle}
                    />
                )}
                {this.state.showCalculator &&
                    <SlidePanel isOpen={this.state.showCalculator} width={"100vw"} showHeader={true}
                                contentClassName="bg-white" from="left" zIndex={defaultSlidePanelZindex}>
                        <DamageCalculator hideDamageCalculator={this.hideDamageCalculator}
                                          id="damage-calculator"
                                          damageEstimatorQuestions={this.state.damageEstimatorQuestions}
                                          isRentalReturnType={this.isRentalReturnType()}
                                          manufactureCode={this.state.manufactureCode}
                                          directReturnCode={this.state.directReturnCode}
                                          categoryCode={this.state.categoryCode}
                                          damage={pricingUtils.buildDamage(this.state)}
                                          updatePricingForDamage={this.updatePricingForDamage}
                                          resetTurnInCalculatorFlag={this.resetTurnInCalculatorFlag}
                                          updateAction={this.updateAction}
                                          updateChargable={this.handleChargeableChange}
                        />
                    </SlidePanel>}
                {this.state.showPricing && <SlidePanel isOpen={this.state.showPricing} width={"100vw"} showHeader={true}
                                                       contentClassName="bg-white" from="right"
                                                       zIndex={defaultSlidePanelZindex + 1}>
                    <Pricing hidePricingOverlay={this.hidePricingOverlay}
                             id="pricing-overlay"
                             damage={pricingUtils.buildDamage(this.state)}
                             pricingTypes={this.state.pricingTypes}
                             handlePricingUpdate={this.handlePricingUpdate}
                             cancelPricingOverlay={this.cancelPricingOverlay}
                    />
                </SlidePanel>}
                {(this.props.globalDisplay.displaySuggestedDamages && !!this.panelSuggestedDamages()) ?
                    <SuggestedDamages setApiLoading={this.setApiLoading}/>
                    :
                    <OutlinePanel id="add-damage-content" className="bg-white m-4" data-damage-id={this.state.damageId}>
                        <PanelHead className="panel-head-add-damage text-right">
                            {this.props.hasActiveImage(this.state.damageId) &&
                                this.state.showImage && (
                                    <Button
                                        color="secondary"
                                        onClick={this.toggleFlatCar}
                                        id="back-to-flatcar-button"
                                    >
                                        Back to Flat Car
                                    </Button>
                                )}
                        </PanelHead>
                        {this.state.isDuplicateDamage &&
                            <Message id="duplicate-damage-message" color="danger">
                                This damage combination already exists.
                            </Message>
                        }
                        <Col xs={12}>
                            <Row>
                                <Col xs={12} className="px-0">
                                    <FormGroup className="flex-grow-1">
                                        <Input.Label className="font-weight-bold">
                                            Item
                                        </Input.Label>
                                        <AsyncTypeahead
                                            ref={(ref) => this._typeahead = ref}
                                            isLoading={this.state.isLoading}
                                            emptyLabel={null}
                                            name="add-damage-item"
                                            id="add-damage-item-list"
                                            placeholder="Search All Damage Items"
                                            onSearch={this.handleTextChange}
                                            onChange={this.handleItemChange}
                                            options={this.state.options}
                                            iconRight="prism-icon-search icon"
                                            autoComplete="off"
                                            useCache={false}
                                            selected={this.state.selectedItem && this.state.selectedItem}
                                            open={this.showItemList()}
                                            defaultOpen={false}
                                            style={{border: '1px solid #babcbe'}}
                                            disabled={this.state.isAutoDamage}
                                        />
                                    </FormGroup>
                                    {!this.state.validation.itemIsValid && (
                                        <Row className="col-12" style={{marginTop: "-16px"}}>
                                            <div
                                                className="invalid-feedback"
                                                id="item-search-validation-message"
                                                style={{display: "block"}}
                                            >
                        <span>
                          <i className="icon prism-icon-notification-circle text-danger"/>{" "}
                            {this.state.itemValidationMessage}
                        </span>
                                            </div>
                                        </Row>
                                    )}
                                    <FormGroup>
                                        <Input.Label className="font-weight-bold">
                                            Damage
                                        </Input.Label>
                                        <DamageDropdown
                                            onChange={this.handleDamageChange}
                                            value={this.state.damageCode}
                                            item={{
                                                itemCode: this.state.itemCode,
                                                subItemCode: this.state.subItemCode,
                                            }}
                                            groupCode={this.props.account.groupCode}
                                            categoryCode={this.props.consignment.categoryCode}
                                            setStatusMessage={this.setStatusMessage}
                                            disabled={this.state.isAutoDamage}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Input.Label className="font-weight-bold">
                                            Severity
                                        </Input.Label>
                                        <SeverityDropdown
                                            onChange={this.handleSeverityChange}
                                            value={this.state.severityCode}
                                            item={{
                                                itemCode: this.state.itemCode,
                                                subItemCode: this.state.subItemCode,
                                            }}
                                            damageCode={this.state.damageCode}
                                            groupCode={this.props.account.groupCode}
                                            categoryCode={this.props.consignment.categoryCode}
                                            setStatusMessage={this.setStatusMessage}
                                            disabled={this.state.isAutoDamage}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Input.Label className="font-weight-bold">
                                            Chargeable
                                        </Input.Label>
                                        <ChargeableDropdown
                                            onChange={this.handleChargeableChange}
                                            value={this.state.chargeable}
                                            description={this.state.chargeableDescription}
                                            item={{
                                                itemCode: this.state.itemCode,
                                                subItemCode: this.state.subItemCode,
                                            }}
                                            damageCode={this.state.damageCode}
                                            severityCode={this.state.severityCode}
                                            groupCode={this.props.account.groupCode}
                                            categoryCode={this.props.consignment.categoryCode}
                                            setStatusMessage={this.setStatusMessage}
                                        />
                                        <div style={{display: "none"}}>
                                            <ActionDropdown
                                                onChange={this.handleActionChange}
                                                value={this.state.actionCode}
                                                item={{
                                                    itemCode: this.state.itemCode,
                                                    subItemCode: this.state.subItemCode,
                                                }}
                                                damageCode={this.state.damageCode}
                                                severityCode={this.state.severityCode}
                                                groupCode={this.props.account.groupCode}
                                                categoryCode={this.props.consignment.categoryCode}
                                                auctionCode={this.props.workOrderInfo.auctionCode}
                                                setStatusMessage={this.setStatusMessage}
                                                handleShowEstimateError={this.handleShowEstimateError}
                                                isCRSO={isCRSO}
                                                disabled={true}
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>

                            {isCRSO &&
                                <DamagePricingInputs
                                    data={this.state}
                                    damageNotChargeable={this.state.damageNotChargeable}
                                    damage={this.props.damage}
                                    toggle={this.props.toggle}
                                    handleUpdatePricing={this.handleUpdatePricing}
                                    handleManualUpdatePricing={this.handleManualUpdatePricing}
                                    priceChange={this.handlePriceChange}
                                    handleInputValidation={this.handleInputValidation}/>}
                            {isCRSO &&
                                <Row>
                                    <Col className="font-weight-bold px-0 flex-grow-1">
                                        <TextCounter
                                            ref={(ref) => this.partDescriptionRef = ref}
                                            label="Part Number/Description"
                                            rows="1"
                                            id='part-description'
                                            onChange={this.handleEditPartDescriptionChange}
                                            value={this.state.partDescription}
                                            maxLength={30}
                                            disabled={this.state.disabled}
                                        />
                                    </Col>
                                    <Col className="pt-4 pr-0 flex-grow-0">
                                        <Button
                                            id='damage-calculator-button'
                                            onClick={this.showDamageCalculator}
                                            disabled={!this.state.actionCode}
                                            className={"mx-1 w-100 bg-cerulean-light"}>
                                            <i className="icon prism-icon-file-spreadsheet"/>
                                        </Button>
                                    </Col>
                                </Row>

                            }
                            <Row className="mt-3">
                                <Col className="col-12 font-weight-bold px-0">
                                    <TextCounter
                                        ref={(ref) => this.damageCommentsRef = ref}
                                        id="damage-comments"
                                        onChange={this.handleNotesChange}
                                        placeholder="Enter Comments"
                                        label="Damage Comments"
                                        maxLength={30}
                                        rows="1"
                                        value={this.state.notes}
                                    />
                                </Col>
                            </Row>
                            <Row className={"mx-0 mt-4"}>
                                {this.hasActivePhoto() &&
                                !this.state.showImage ?
                                    (
                                        <Button
                                            className="w-100"
                                            color="secondary"
                                            onClick={this.toggleFlatCar}
                                            id="show-damage-photo-button"
                                            disabled={this.state.isDuplicateDamage}
                                        >
                                            Show Photo
                                        </Button>
                                    )
                                    :
                                        (
                                            <TakePhoto
                                                hasPhoto={this.props.hasActiveImage(this.state.damageId)}
                                                photoIsRequired={this.photoIsRequired()}
                                                damage={this.state}
                                                damageKey={this.state.damageKey}
                                                damageId={this.state.damageId}
                                                isDuplicateDamage={this.state.isDuplicateDamage}
                                            />
                                        )
                                }
                            </Row>
                            {isCRSO && this.state.showPricingInputError ?
                                <Message id="missing-prices-message" color="danger"><i
                                    className="icon prism-icon-notification-circle" color="danger"/>
                                    {this.state.showEstimateError ? MISSING_ESTIMATE_MESSAGE : this.state.showPricingInputError ? MISSING_PRICING_MESSAGE : ''}
                                </Message> : <></>}
                            {isCRSO && this.state.damageNotChargeable ?
                                <Message id="no-pricing-required" color="success"><i
                                    className="icon prism-icon-notification-circle" color="success"/>
                                    {`The action on this damage is "${this.state.action}," no pricing is required.`}
                                </Message> : <></>}
                            <Row className={"my-4"}>
                                <Col xs={6}>
                                    <Button
                                        className="w-100"
                                        outline
                                        onClick={this.handleCancelClick}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                                <Col xs={6}>
                                    <Button
                                        className="w-100"
                                        color="secondary"
                                        disabled={this.saveButtonDisabled()}
                                        onClick={this.handleSaveDamage}
                                    >
                                        Save
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </OutlinePanel>}
            </>
        );
    }
}

const mapDispatchToProps = {
    showDamageListView,
    addDamage,
    updateDamage,
    getActiveImage,
    getActiveImageObject,
    hasActiveImage,
    updateDamageImage,
    deleteDamageImage,
    addAnnouncementForDamage,
    addAnnouncementByCode,
    addAutoDamage,
    deleteDamage,
    showExteriorFlatCarView,
    showCurrentFlatCarView,
    clearItemsList,
    clearSelectedFlatCarPanel,
    manuallyAddSuggestedDamage,
    showSuccessMessage,
    logObject,
    showSuggestedDamagesPanel,
    saveIncompleteDamage,
    clearIncompleteDamage,
    setClearPanelOn,
    showAddEditDamage,
    handlePanelClick
};

function mapStateToProps(
    {
        automatedDamages,
        globalDisplay,
        account,
        consignment,
        workOrderInfo,
        damageImages,
        condition,
        damageRules,
        designatedDescription,
        designatedDescriptionResponse,
        unit,
        suggestedDamages,
        validationFailed
    }
) {
    return {
        automatedDamages,
        globalDisplay,
        account,
        consignment,
        workOrderInfo,
        damageImages,
        condition,
        damageRules,
        designatedDescription,
        designatedDescriptionResponse,
        unit,
        suggestedDamages,
        validationFailed
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(DamageEditView);